export default {
  addOns: '附加项目',
  all: '全部',
  browse: '浏览',
  buyTickets: '购买门票',
  countSelected: '已选 {{count}}',
  joinWaitlist: '加入候补名单',
  joining: '正在加入',
  noDatesAvailable: '暂无可用日期',
  salesEnded: '销售已结束',
  schedule: '日程',
  seeMoreDates: '查看更多日期',
  soldOut: '已售罄',
  about: '关于',
  agenda: '议程',
  menu: '菜单',
  included: '包含内容',
  viewMore: '查看更多',
  viewLess: '收起',
  location: '地点',
  time: '时间',
  at: '在',
  noTimesAvailableOnThisDateFotThisPartySize: '该日期暂无符合此人数的可用时间',
  availableTimes: '可用时间',
  waitlist: '候补名单',
  continue: '继续',
  tickets: '票',
  ticketsAreNoLongerAvailable: '门票不再可用。',
  checkOutOutOtherExperiences: '看看我们的其他体验项目！',
  viewExperiences: '查看体验',
  from: '起',
  cancellationPolicy: '取消政策',
  rsvp: '回复邀请',
  nights: '晚',
  request: '请求',
  arrival: '到达',
  departure: '离开',
};
